module.exports = __webpack_public_path__ + "static/media/kerala.48f551ff.png";